import React from 'react';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import SMMFeaturesData from '../../data/smm/SMMFeatures.json';
import SectionTitle from '../../elements/section-title/SectionTitle';

const BestForYouSection = () => {
    return (
        <div className="section section-padding relative">
            <div className="container">
                <div className="section-heading heading-center mb--40">
                    <SectionTitle
                        subtitle="Our Process"
                        title="Best For You"
                        textAlignment="heading-center"
                        textColor=""
                        paragraphClass="d-none"
                    />
                </div>
                <div className="row g-4" style={{ paddingBottom: '60px' }}>
                    {SMMFeaturesData.map((feature, index) => (
                        <div className="col-lg-3 col-md-6" key={index} style={{ position: 'relative' }}>
                            <AnimationOnScroll
                                animateIn="fadeInUp"
                                animateOnce={true}
                                delay={index * 100}
                            >
                                <div className="feature-card text-center smm-feature-card">
                                    {/* Curved dotted line connector using your SVG */}
                                    {index < SMMFeaturesData.length - 1 && (
                                        <svg
                                            className="connector-line"
                                            style={{
                                                position: 'absolute',
                                                top: '65px',
                                                left: '85%',
                                                right: '-15%',
                                                zIndex: 0,
                                                overflow: 'visible',
                                                transform: index % 2 === 0 ? 'scaleY(1)' : 'scaleY(-1)'
                                            }}
                                            viewBox="0 0 111 14"
                                            fill="none"
                                            preserveAspectRatio="none"
                                        >
                                            <path
                                                d="M0.179688 8.05756C17.6492 1.33853 64.1064 -7.03145 110.18 13.2408"
                                                stroke="#A6A8B0"
                                                strokeDasharray="4 5"
                                                fill="none"
                                            />
                                        </svg>
                                    )}

                                    <div className="d-flex" style={{
                                        borderRadius: '50%',
                                        borderWidth: '1px',
                                        border: `2px solid ${feature.color}`,
                                        width: "fit-content",
                                        marginInline: "auto",
                                        padding: "16px 10px 0px 10px",
                                        position: 'relative',
                                        zIndex: 1,
                                        backgroundColor: 'white'
                                    }}>
                                        <div className="icon-wrapper" style={{
                                            width: '70px',
                                            height: '70px',
                                            margin: '0',
                                            borderRadius: '50%',
                                            backgroundColor: feature.color,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: "white",
                                            fontSize: "25px"
                                        }}>
                                            {index + 1}
                                        </div>
                                    </div>
                                    <h5 className="title mt-3 mb-1" style={{
                                        fontSize: "24px"
                                    }}>{feature.title}</h5>
                                    <p className="description" style={{
                                        fontSize: "16px"
                                    }}>{feature.description}</p>
                                </div>
                            </AnimationOnScroll>
                        </div>
                    ))}
                </div>

                <svg
                    width={1920}
                    height={275}
                    viewBox="0 0 1920 275"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="SMM-section-curve-line"
                >
                    <mask
                        id="mask0_24_38"
                        style={{
                            maskType: "luminance",
                        }}
                        maskUnits="userSpaceOnUse"
                        x={0}
                        y={0}
                        width={1920}
                        height={275}
                    >
                        <path
                            d="M0 6.23198C318.332 274.567 688.226 -17.9956 1033.19 0.884379C1245.07 12.478 1640.23 164.457 1920 129.262V274.567H0C0 185.122 0 95.6773 0 6.23198Z"
                            fill="white"
                        />
                    </mask>
                    <g mask="url(#mask0_24_38)">
                        <path d="M1920 -18H0V274.563H1920V-18Z" fill="#F2F2FF" />
                    </g>
                </svg>

            </div>

            <style jsx>{`

            .smm-feature-card {
                 padding: 40px 0;
                 border-radius: 10px;
                 height: 100%;
                 transition: transform 0.3s ease, box-shadow 0.3s ease;
            }

            .SMM-section-curve-line {
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                top: 84.5%;
                z-index: -1;
            }

                @media (max-width: 991px) {
                    .row.g-4 {
                        padding-bottom: 80px !important;
                    }
                }

                @media (max-width: 767px) {
                    .row.g-4 {
                        padding-bottom: 100px !important;
                    }
                }

                @media (max-width: 991px) {
                    .connector-line {
                        display: none;
                    }
                }

                @media (max-width: 575px) {
                    .row.g-4 {
                        padding-bottom: 60px !important;
                    }

                .smm-feature-card {
                 padding: 0;
                }

                .SMM-section-curve-line {
                top: 87%;
                width: 100%;
            }
            }
            `}</style>
        </div>
    );
};

export default BestForYouSection;